import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ConfigurationOptionListsView } from "src/components/views/erp/configurator/managing/optionLists/ConfigurationOptionListsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/configurator/optionLists")({
	staticData: { title: i18n.t("option_lists"), legacyViewKey: "configurationOptionListsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ConfigurationOptionListsView />;
}
